import { persistentMap } from "@nanostores/persistent";

export type UserAppSettingsValue = {
  autoLayoutAfterWorkflow: boolean;
  showEdgesLabels: boolean;
  sidebarLeftVisible: boolean;
  sidebarRightVisible: boolean;
  statusBarVisible: boolean;
};

export const $userAppSettings = persistentMap<UserAppSettingsValue>(
  "MiruVizUserAppSettingsValue:",
  {
    autoLayoutAfterWorkflow: true,
    showEdgesLabels: false,
    sidebarLeftVisible: true,
    sidebarRightVisible: true,
    statusBarVisible: true,
  },
  {
    decode: JSON.parse,
    encode: JSON.stringify,
  },
);
